/**
* Timer
*/


(function( $ ) {

  var finishDate;

  if ($('#finishdate').html() != '') {
    finishDate = new Date($('#finishdate').html());
  } else {
    // If not set use some random date in future
    finishDate = new Date();
    finishDate.setTime( finishDate.getTime() + getRandomInt(20,40)*3600*1000 );
  }


    $.fn.timer = function(params) {
        var html = "<div class='_time days'><h3>" +  "</h3><label>Days</label></div>";
        html += "<div class='_time hours'><h3>" + "</h3><label>Hours</label></div>";
        html += "<div class='_time minutes'><h3>" + "</h3><label>Mins</label></div>";
        html += "<div class='_time seconds'><h3>" + "</h3><label>Secs</label></div>";
        this.html(html);
      	var ths = this;
      	
       	setInterval(function(){
	      	rem_time = get_formated_remaining_time(finishDate);
            ths.find('.days h3').text(twoDigit(rem_time.days));
            ths.find('.hours h3').text(twoDigit(rem_time.hours));
            ths.find('.minutes h3').text(twoDigit(rem_time.minutes));
            ths.find('.seconds h3').text(twoDigit(rem_time.seconds));
      	}, 1000);
    };

    function twoDigit(number) {
      var twodigit = number >= 10 ? number : "0"+number.toString();
      return twodigit;
    }

    function get_formated_remaining_time(date){
        var remain = (date.getTime() - (new Date()).getTime())/1000;
        if (remain < 0) return {days:0, hours:0, minutes:0, seconds:0}

        var humanReadable = {};
        humanReadable.days = Math.floor(remain/86400);
        remain = remain % 86400;

        humanReadable.hours = Math.floor(remain/3600);
        remain = remain % 3600;

        humanReadable.minutes = Math.floor(remain/60);
        remain = remain % 60;

        humanReadable.seconds = Math.round(remain);

        return humanReadable;
    }

  function getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

}( jQuery ));

